module.exports = __webpack_public_path__ + "aeronave_voo.png?12200a35f6d645f2450ec5dd291519a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aeronave_voo.png
// module id = 426
// module chunks = 0